import React from "react";
import { DefaultButton, IButtonProps, TooltipHost } from "office-ui-fabric-react";
import { theme } from "theme";

const CustomCommandButtonWithTooltip = (props: IButtonProps) => {
  return (
    <TooltipHost content={props.title} id={'editVehCompoundButton'} calloutProps={{ gapSpace: 0 }} hidden={!props.disabled}>
      <DefaultButton
        {...props}
        styles={{
          root: {
            width: '100%',
            height: '100%',
          },
          icon: {
            color: theme.colors.themePrimary
          }
        }}
        disabled={props.disabled}
      >
        {props.name}
      </DefaultButton>
    </TooltipHost>
  )
};

export default CustomCommandButtonWithTooltip;